import { z } from 'zod';
/**
 * Bounds for the chat rail (uiv2 BE3a). Declared once so the route, the
 * migration's comment and the page agree.
 */
/**
 * The context slices an answer can cite (uiv2 BE3b, CH-14) — one per block
 * `fetchDatabaseContext` fills. `categories` is reference data, not evidence,
 * and is not cited.
 */
export const CHAT_CONTEXT_SOURCE_KINDS = [
    'search',
    'transactions',
    'invoices',
    'billers',
    'taxes',
    'employees',
    'timesheets',
    'pos',
];
/** Every tool the assistant can call — `CHAT_TOOLS` in the api, pinned equal by a test. */
export const CHAT_TOOL_NAMES = ['get_price_hikes', 'get_pos_sales', 'get_pos_menu_items', 'compare_pos_periods'];
/** How many of a tool's rows an answer keeps for its table. */
export const CHAT_TABLE_ROWS_SHOWN = 20;
/** At most this many follow-up questions per answer, each at most this many code points. */
export const CHAT_FOLLOWUPS_MAX = 3;
export const CHAT_FOLLOWUP_MAX_LENGTH = 140;
/** A thread's title is its first question, clipped to this many code points. */
export const CHAT_THREAD_TITLE_MAX = 120;
/** How many threads the rail's Recent list shows (newest activity first). */
export const CHAT_THREADS_SHOWN = 50;
/**
 * A question's length, in code points (release review, v2026.9.28). The body
 * limit was the only cap (10 MB), and every stored turn is replayed into the
 * next prompt — so one pasted document billed the workspace's key on every
 * later question in the thread. Four thousand is several pages of text.
 */
export const CHAT_MESSAGE_MAX_LENGTH = 4000;
/** A saved prompt's length, in code points, and how many one user may keep per workspace. */
export const CHAT_SAVED_PROMPT_MAX_LENGTH = 500;
export const CHAT_SAVED_PROMPTS_MAX = 20;
/**
 * A thread title from a question: whitespace runs collapsed to one space,
 * trimmed, and clipped by CODE POINT — never mid-surrogate.
 */
export function chatThreadTitle(question) {
    return Array.from(question.replace(/\s+/g, ' ').trim()).slice(0, CHAT_THREAD_TITLE_MAX).join('');
}
/** `POST` / `PATCH /chat/saved-prompts` body. */
export const chatSavedPromptSchema = z.object({
    content: z
        .string()
        .transform((s) => s.trim())
        .refine((s) => s.length > 0, 'empty')
        .refine((s) => Array.from(s).length <= CHAT_SAVED_PROMPT_MAX_LENGTH, 'too long'),
});
//# sourceMappingURL=chat.js.map